(function () {
  function setPanelHeight(item, isOpening) {
    const panel = item.querySelector('[data-accordion-panel]');
    const inner = panel.querySelector('.product-ingredients__panel-inner');
    if (!panel || !inner) return;

    if (isOpening) {
      panel.style.maxHeight = inner.offsetHeight + 'px';
    } else {
      panel.style.maxHeight = '0px';
    }
  }

  function init() {
    document.querySelectorAll('[data-ingredients-accordion]').forEach(accordion => {
      // Set initial heights for items already marked as open
      accordion.querySelectorAll('[data-accordion-item].is-open').forEach(item => {
        setPanelHeight(item, true);
      });

      accordion.querySelectorAll('[data-accordion-toggle]').forEach(toggle => {
        toggle.addEventListener('click', () => {
          const item = toggle.closest('[data-accordion-item]');
          const isOpen = item.classList.contains('is-open');

          // Close all
          accordion.querySelectorAll('[data-accordion-item]').forEach(i => {
            i.classList.remove('is-open');
            i.querySelector('[data-accordion-toggle]').setAttribute('aria-expanded', 'false');
            setPanelHeight(i, false);
          });

          // Open the clicked one if it wasn't already
          if (!isOpen) {
            item.classList.add('is-open');
            toggle.setAttribute('aria-expanded', 'true');
            setPanelHeight(item, true);
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);

  // Recalculate heights on resize (in case content wrapping changes)
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      document.querySelectorAll('[data-accordion-item].is-open').forEach(item => {
        setPanelHeight(item, true);
      });
    }, 150);
  });
})();